import React from 'react';
import {
    Brain, Globe, Search
} from 'lucide-react';
import {
    cn
} from 'shared/lib/utils';
import {
    EMPTY_CTA
} from './copy';

/**
 * Empty-state starter CTAs when opcode has no steps.
 */
export default function OpcodeEmptyStateCTAs({
    onStartRagAnswer,
    onStartApiSummarize,
    onStartLlmOnly,
    compact = false
}) {
    const cards = [
        {
            icon: Search,
            color: 'text-blue-500',
            ...EMPTY_CTA.ragAnswer,
            onClick: onStartRagAnswer
        },
        {
            icon: Globe,
            color: 'text-green-500',
            ...EMPTY_CTA.apiSummarize,
            onClick: onStartApiSummarize
        },
        {
            icon: Brain,
            color: 'text-violet-500',
            ...EMPTY_CTA.llmOnly,
            onClick: onStartLlmOnly
        },
    ];

    return (
        <div className={cn('grid gap-2', compact ? 'grid-cols-1' : 'sm:grid-cols-3')}>
            {cards.map((c) => {
                const Icon = c.icon;
                return (
                    <button
                        key={c.title}
                        type="button"
                        onClick={c.onClick}
                        className={cn(
                            'text-left transition-colors',
                            compact
                                ? 'rounded-sm bg-muted/25 p-3 hover:bg-muted/45'
                                : 'rounded-sm border bg-card p-4 hover:border-primary hover:bg-primary/5'
                        )}
                    >
                        <Icon className={cn('h-5 w-5 mb-2', c.color)} />
                        <div className="text-sm font-semibold">{c.title}</div>
                        <div className="mt-1 text-xs text-muted-foreground">{c.description}</div>
                    </button>
                );
            })}
        </div>
    );
}
